import {post} from '../script/serviceApiPost';
import {get} from '../script/serviceApiGet';

export default{
  async save(dataRow: any) {
    const result = await post('funDetailData/save', dataRow);
    return result;
  },

  async saveBatch(dataRow: any) {
    const result = await post('funDetailData/saveBatch', dataRow);
    return result;
  },
  
  async removeByIds(dataRow: any) {
    const result = await post('funDetailData/removeByIds', dataRow);
    return result;
  },
  async removeByBatchId(dataRow: any) {
    const result = await post('funDetailData/removeByBatchId', dataRow);
    return result;
  },
  async updateById(dataRow: any) {
    const result = await post('funDetailData/updateById', dataRow);
    return result;
  },
  async getById(dataRow: any) {
    const result = await post('funDetailData/getById', dataRow);
    return result;
  },
  async selectPageData(dataRow: any) {
    const result = await post('funDetailData/selectPageData', dataRow);
    return result;
  },
  async selectColumnAndDataMap(dataRow: any) {
    const result = await post('funDetailData/selectColumnAndDataMap', dataRow);
    return result;
  },
  async selectByDetailId(dataRow: any) {
    const result = await post('funDetailData/selectByDetailId', dataRow);
    return result;
  },
  async selectFunDetailDataCountByFunId(dataRow: any) {
    const result = await post('funDetailData/selectFunDetailDataCountByFunId', dataRow);
    return result;
  },
  
  
  
};
